"use strict";

const startTogglePasswordVisibilityHandlers = () => {
    $(".form-group-password i.icon-show-password").on("click", function () {
        var $icon           = $(this);
        var $inputContainer = $icon.parent();
        var $input          = $inputContainer.find("input");

        if ($input.attr("type") === "password") {
            $input.attr("type", "text");
            $icon.removeClass("icon-show-password").addClass("icon-hide-password");
        } else {
            $input.attr("type", "password");
            $icon.removeClass("icon-hide-password").addClass("icon-show-password");
        }
    });

    $(".form-group-password i.icon-hide-password").on("click", function () {
        var $icon           = $(this);
        var $inputContainer = $icon.parent();
        var $input          = $inputContainer.find("input");

        if ($input.attr("type") === "text") {
            $input.attr("type", "password");
            $icon.removeClass("icon-hide-password").addClass("icon-show-password");
        }
    });
};

const startStepperHandlers = () => {
    const $document = $(document);

    $(".js-stepper").each(function () {
        var $stepper = $(this);
        var $input   = $stepper.find(".js-stepper-input");
        var value    = parseInt($input.val(), 10);

        if (value === 1) {
            $input.val(1);
            $stepper.find(".js-stepper-minus").hide();
            $stepper.find(".js-stepper-trash").show();
        } else {
            $stepper
                .find(".js-stepper-minus")
                .show()
                .toggleClass("disabled", value === 0);
            $stepper.find(".js-stepper-trash").hide();
        }
    });

    $document.on("change", ".js-stepper .js-stepper-input", function () {
        var $input = $(this);
        var value  = parseInt($input.val(), 10);
        var max    = parseInt($input.attr("max"), 10);

        if (value >= max) {
            $input.val(max);
            $input.siblings(".js-stepper-trash").hide();
            $input.siblings(".js-stepper-minus").show();
            $input.siblings(".js-stepper-plus").addClass("disabled");
        } else if (value <= 0) {
            $input.val(0);
            $input.siblings(".js-stepper-minus").show().toggleClass("disabled", true);
            $input.siblings(".js-stepper-trash").hide();
        } else if (value === 1) {
            //Show trash can when value is exactly one
            $input.siblings(".js-stepper-minus").hide();
            $input.siblings(".js-stepper-trash").show();
        } else {
            //Otherwise, show the default minus and plus icon, and make sure both are enabled
            $input.siblings(".js-stepper-minus").show().toggleClass("disabled", false);
            $input.siblings(".js-stepper-plus").toggleClass("disabled", false);
            $input.siblings(".js-stepper-trash").hide();
        }
    });

    $document.on("click", ".js-stepper .js-stepper-minus", function () {
        var $button = $(this);
        var $input  = $button.siblings(".js-stepper-input");
        var value   = parseInt($input.val(), 10);
        var max     = parseInt($input.attr("max"), 10);

        if (value > 1) {
            $input.val(value - 1);
        }

        value = parseInt($input.val(), 10);

        if (value === 1) {
            $button.hide();
            $button.siblings(".js-stepper-trash").show();
        }

        if (value === 0) {
            $button.addClass("disabled");
        }

        if (value < max && value !== 0) {
            $button.removeClass("disabled");
            $button.siblings(".js-stepper-plus").removeClass("disabled");
        }
    });

    $document.on("click", ".js-stepper .js-stepper-trash", function () {
        var $button = $(this);
        var $input  = $button.siblings(".js-stepper-input");

        $input.val(0);

        $button.hide();
        $button.siblings(".js-stepper-minus").show().toggleClass("disabled", true);
    });

    $document.on("click", ".js-stepper .js-stepper-plus", function () {
        var $button = $(this);
        var $input  = $button.siblings(".js-stepper-input");
        var value   = parseInt($input.val(), 10);
        var max     = parseInt($input.attr("max"), 10);

        if (value < max) {
            $input.val(value + 1);
        }

        value = parseInt($input.val(), 10);

        if (value > 1) {
            $button.siblings(".js-stepper-minus").show();
            $button.siblings(".js-stepper-trash").hide();
        }

        if (value >= max) {
            $button.addClass("disabled");
        } else {
            $button.removeClass("disabled");
        }
    });

    $document.on("input", ".js-stepper .js-stepper-input", function (event) {
        var formControl = $(event.target);
        var newText     = formControl.val().replace(/[^0-9]+/g, "");

        formControl.val("");
        formControl.val(newText);
    });
};

const initializeInputScripts = () => {
    startTogglePasswordVisibilityHandlers();
    startStepperHandlers();
};

export default initializeInputScripts;
